import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const FeaturesContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1.5rem;
  }
`;

const FeatureCard = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 1.5rem;
  border-radius: 15px;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-5px);
  }

  h3 {
    color: #ff3333;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  p {
    line-height: 1.6;
    font-size: 0.95rem;
    opacity: 0.9;
  }
  
  @media (max-width: 768px) {
    padding: 1.25rem;
    
    h3 {
      font-size: 1.1rem;
      margin-bottom: 0.75rem;
    }
    
    p {
      font-size: 0.9rem;
      line-height: 1.5;
    }
  }
`;

const Features = () => {
  const features = [
    {
      title: 'Secure File Storage',
      description: 'Enterprise-grade encryption for all your files with advanced access controls and user management.'
    },
    {
      title: 'File Sharing & Collaboration',
      description: 'Share files and folders easily with team members or external partners with granular permissions.'
    },
    {
      title: 'Auto Sync',
      description: 'Automatic synchronization across all your devices, ensuring you always have the latest version.'
    },
    {
      title: 'Version Control',
      description: 'Keep track of file changes and restore previous versions when needed.'
    },
    {
      title: 'Mobile Access',
      description: 'Access your files on the go with the Nextcloud mobile apps for iOS and Android.'
    },
    {
      title: 'Regular Backups',
      description: 'Automated backup systems ensure your data is always safe and recoverable.'
    }
  ];

  return (
    <FeaturesContainer>
      <PageHeader title="Our Features" highlightWord="Features" />
      <FeaturesGrid>
        {features.map((feature, index) => (
          <FeatureCard key={index}>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </FeatureCard>
        ))}
      </FeaturesGrid>
    </FeaturesContainer>
  );
};

export default Features;
